// Test A/B VWO: popup informativo de la pill de oferta.
// Solo actúa si VWO ha añadido la clase 'vwo-badge-popup' a <html>.
// Usa delegación en document porque el badge se vuelve a pintar al cambiar de variante.
(function () {
  const ACTIVE_CLASS = 'vwo-badge-popup';
  const TRIGGER_SELECTOR = '[data-badge-popup-trigger]';

  function isActive() {
    return document.documentElement.classList.contains(ACTIVE_CLASS);
  }

  function getPopup() {
    return document.getElementById('BadgeSalePopup');
  }

  // Lo saca de la columna de producto a <body> para que position: fixed sea respecto a la ventana
  const initialPopup = getPopup();
  if (initialPopup && initialPopup.parentElement !== document.body) {
    document.body.appendChild(initialPopup);
  }

  function isOpen() {
    const popup = getPopup();
    return Boolean(popup) && !popup.hidden;
  }

  function setOpen(open) {
    const popup = getPopup();
    if (!popup) return;

    popup.hidden = !open;
    document.querySelectorAll(TRIGGER_SELECTOR).forEach((trigger) => {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  document.addEventListener('click', (event) => {
    if (!isActive()) return;

    // Clic en el badge: abre o cierra
    if (event.target.closest(TRIGGER_SELECTOR)) {
      setOpen(!isOpen());
      return;
    }

    // Clic en cualquier otro sitio (incluido el popup): cierra
    if (isOpen()) setOpen(false);
  });

  document.addEventListener('keydown', (event) => {
    if (!isActive()) return;

    if (event.key === 'Escape') {
      if (isOpen()) setOpen(false);
      return;
    }

    if ((event.key === 'Enter' || event.key === ' ') && event.target.closest?.(TRIGGER_SELECTOR)) {
      event.preventDefault();
      setOpen(!isOpen());
    }
  });
})();
